<template>
  <section class="py-12">
    <div class="container-wrap">
      <h2 class="text-h1 mb-6">{{ sectionData.name }}</h2>
      <ul class="column-421 mb-6">
        <li v-for="(item, index) in sectionData.subSections" :key="hash(item)">
          <div class="flex tablet:block">
            <TheStepsNumber :step-digit="index + 1" />
            <div class="grow basis-0 py-2.5 pl-3 tablet:pl-0">
              <h3 class="text-h4 mb-1">{{ item.name }}</h3>
              <p class="text-base text-gray-600">{{ item.description }}</p>
            </div>
          </div>
        </li>
      </ul>
      <TheButton
        v-if="sectionData.link"
        :id="isCN ? 'tracking_dialogue' : undefined"
        :to="sectionData.link?.url"
        :title="sectionData.link?.name || ''"
        class="w-[180px]"
        @click="handleClick"
      >
        <span class="text-sm">{{ sectionData.link?.name }}</span>
      </TheButton>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });

  const { isCN } = useLanguage();

  const handleClick = (): void => {
    window.gtag('event', 'site_click', { Item: 'JoinUsNowButton' });
  };
</script>
